import { ReactNode, memo, useState } from "react";

import ExternalLink from "../ExternalLink/ExternalLink";
import TooltipContainer from "../TooltipContainer/TooltipContainer";
import { removeWikiUrl } from "../Wikipedia/utils";
import Wikipedia from "../Wikipedia/Wikipedia";

interface Props {
  to: string;
  query?: string;
  favicon?: boolean;
  children?: ReactNode;
}

const Wikilink = ({ to, query, favicon, children }: Props): JSX.Element => {
  const [hasHovered, setHasHovered] = useState(false);

  return (
    <TooltipContainer
      onMouseOver={() => setHasHovered(true)}
      onFocus={() => setHasHovered(true)}
    >
      {hasHovered && (
        <span>
          <Wikipedia query={query || removeWikiUrl(to)} url={to} />
        </span>
      )}
      <ExternalLink to={to} favicon={favicon}>
        {children}
      </ExternalLink>
    </TooltipContainer>
  );
};

Wikilink.defaultProps = {
  query: undefined,
  favicon: undefined,
  children: undefined,
};

export default memo(Wikilink);
